/* ProGym Saint-Jérôme — motion.js
   IntersectionObserver reveals, count-up, reading progress, marquee.
   GPU transforms/opacity only. No dependencies. Respects reduced motion. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reducedByTheme = root.getAttribute('data-reduce-motion') === 'true';
  var reducedByOS = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REDUCED = reducedByTheme || reducedByOS;

  /* ---- Reveals + count triggers ------------------------------------- */
  function showAll() {
    document.querySelectorAll('[data-anim]').forEach(function (el) {
      el.classList.add('is-in');
    });
    document.querySelectorAll('.count[data-count]').forEach(function (el) {
      el.textContent = format(parseFloat(el.getAttribute('data-count')) || 0);
    });
  }

  if (REDUCED || !('IntersectionObserver' in window)) {
    if (document.readyState !== 'loading') showAll();
    else document.addEventListener('DOMContentLoaded', showAll);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-count')) runCount(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  function init() {
    document.querySelectorAll('[data-anim]').forEach(function (el, i) {
      if (el.hasAttribute('data-stagger')) el.style.setProperty('--i', i % 8);
      io.observe(el);
    });
    document.querySelectorAll('.count[data-count]').forEach(function (el) {
      el.textContent = format(0);
      io.observe(el);
    });
    initProgress();
    initMarquee();
    initNewsletter();
  }

  /* ---- Count-up ------------------------------------------------------ */
  function format(n) {
    return Math.round(n).toLocaleString('en-US');
  }
  function runCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dur = parseInt(el.getAttribute('data-count-dur'), 10) || 1400;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      // ease-out cubic for a fast slam then settle
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = format(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = format(target);
    }
    requestAnimationFrame(step);
  }

  /* ---- Reading progress --------------------------------------------- */
  function initProgress() {
    var bar = document.querySelector('.progress__bar');
    if (!bar) return;
    var article = document.querySelector('[data-progress-target]') || document.body;
    var ticking = false;
    function update() {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- Marquee: duplicate track for seamless loop ------------------- */
  function initMarquee() {
    document.querySelectorAll('.marquee__track').forEach(function (track) {
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
      // wrap both in a shared animation by moving into a flex row
      var wrapper = document.createElement('div');
      wrapper.style.display = 'flex';
      wrapper.style.width = 'max-content';
      wrapper.style.willChange = 'transform';
      wrapper.className = 'marquee__track';
      wrapper.style.animationDuration = getComputedStyle(track).animationDuration;
      track.classList.remove('marquee__track');
      clone.classList.remove('marquee__track');
      track.style.animation = 'none';
      track.parentNode.insertBefore(wrapper, track);
      wrapper.appendChild(track);
      wrapper.appendChild(clone);
    });
  }

  /* ---- Newsletter success flash ------------------------------------- */
  function initNewsletter() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      var note = document.querySelector('[data-news-success]');
      if (note) { note.hidden = false; note.focus && note.focus(); }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
